module.exports = __webpack_public_path__ + "img/117.2.694cb0a6.png";